import { Component } from '@angular/core';

@Component({
  selector: 'app-crud-lyfis-question',
  templateUrl: './crud-lyfis-question.component.html',
  styleUrl: './crud-lyfis-question.component.scss'
})
export class CrudLyfisQuestionComponent {

}
